import { getCloudflareImageUrl } from '@/hooks/useCloudflareImage';
import { RawTopCompany } from '../../hooks/useInfiniteInvestingIdeas/types';

export const getTopCompaniesIconList = (
  topCompanies: RawTopCompany[] | undefined
) =>
  topCompanies?.map((company) => {
    const companyIconUrl = getCloudflareImageUrl({
      src: company.info?.url ?? '',
      width: 50,
      blur: 2,
    });
    return companyIconUrl;
  });
